import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { validateTokenAndLogout } from '../utils/auth';

/**
 * Hook to periodically validate the authentication token
 * and automatically logout if the token is invalid
 */
export const useTokenValidation = (intervalMs = 60000) => { // Check every minute by default
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Only run validation if user is supposed to be authenticated
    if (!isAuthenticated) return;

    console.log('🔐 Token validation enabled - checking every', intervalMs / 1000, 'seconds');

    // Initial check
    const isValid = validateTokenAndLogout();
    if (isValid) {
      console.log('✅ Initial token validation passed');
    }

    // Set up periodic validation
    const interval = setInterval(() => {
      const isValid = validateTokenAndLogout();
      if (isValid) {
        console.log('🔄 Periodic token validation passed');
      }
    }, intervalMs);

    return () => {
      console.log('🔐 Token validation disabled');
      clearInterval(interval);
    };
  }, [isAuthenticated, intervalMs]);
};

export default useTokenValidation;